import React from 'react';
import MergeProfilesStepperStep from './MergeProfilesStepperStep';
import { Divider, Flex, Text } from '@televet/kibble-ui';

export enum MergeStep {
  Search,
  Select,
  Confirm,
}

interface IMergeProfilesStepperProps {
  selectedStep: MergeStep;
}

const MergeProfilesStepper = ({ selectedStep }: IMergeProfilesStepperProps): JSX.Element => {
  return (
    <Flex justifyContent="center">
      <Flex direction="column">
        <Flex alignItems="center">
          <MergeProfilesStepperStep index={1} completed={selectedStep > 0} selected={selectedStep === 0} />
          <Divider borderColor="border.info" orientation="horizontal" w="80px" variant="dashed" />
        </Flex>
        <Flex ml={2} direction="column">
          <Text size="xs" fontWeight="bold" mt={3}>
            STEP 1
          </Text>
          <Text size="sm" fontWeight="bold" mt={1}>
            Search Profiles
          </Text>
        </Flex>
      </Flex>
      <Flex direction="column">
        <Flex alignItems="center">
          <MergeProfilesStepperStep index={2} completed={selectedStep > 1} selected={selectedStep === 1} />
          <Divider borderColor="border.info" orientation="horizontal" w="80px" variant="dashed" />
        </Flex>
        <Flex ml={2} direction="column">
          <Text size="xs" fontWeight="bold" mt={3}>
            STEP 2
          </Text>
          <Text size="sm" fontWeight="bold" mt={1}>
            Select Info
          </Text>
        </Flex>
      </Flex>
      <Flex direction="column">
        <Flex alignItems="center" width="fit-content">
          <MergeProfilesStepperStep index={3} completed={selectedStep > 2} selected={selectedStep === 2} />
        </Flex>
        <Flex ml={2} direction="column">
          <Text size="xs" fontWeight="bold" mt={3}>
            STEP 3
          </Text>
          <Text size="sm" fontWeight="bold" mt={1}>
            Confirm Info
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MergeProfilesStepper;
